import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

// [DTS-7163] Ícone de ajuda reutilizável. O Tooltip do MUI exibe o conteúdo em
// hover E em focus do elemento filho automaticamente -- cobre navegação por
// teclado (Tab) sem código adicional, sem exigir libs novas.
export default function CampoAjuda({ texto }) {
    return (
        <Tooltip title={texto} arrow placement="top">
            <i
                className="fas fa-info-circle campoAjudaIcone"
                tabIndex={0}
                role="img"
                aria-label={texto}
            ></i>
        </Tooltip>
    );
}
